import { createLogger } from '@kilat/shared';
import { env } from './env.js';

export const logger = createLogger({
  app: 'agent-pwa',
  minLevel: env.mode === 'production' ? 'info' : 'debug',
  suppressed: env.mode === 'test',
});
